module.exports = __webpack_public_path__ + "static/media/truck.1be8a4af.svg";